//
// Autogenerated by Thrift Compiler (0.13.0)
//
// DO NOT EDIT UNLESS YOU ARE SURE THAT YOU KNOW WHAT YOU ARE DOING
//
"use strict";

var thrift = require("thrift");
var Thrift = thrift.Thrift;
var Q = thrift.Q;
var Int64 = require("node-int64");

var ttypes = (module.exports = {});
var SignatureMetadata = (module.exports.SignatureMetadata = function (args) {
  this.signatureVerificationKey = null;
  this.context = null;
  if (args) {
    if (
      args.signatureVerificationKey !== undefined &&
      args.signatureVerificationKey !== null
    ) {
      this.signatureVerificationKey = args.signatureVerificationKey;
    } else {
      throw new Thrift.TProtocolException(
        Thrift.TProtocolExceptionType.UNKNOWN,
        "Required field signatureVerificationKey is unset!"
      );
    }
    if (args.context !== undefined && args.context !== null) {
      this.context = args.context;
    } else {
      throw new Thrift.TProtocolException(
        Thrift.TProtocolExceptionType.UNKNOWN,
        "Required field context is unset!"
      );
    }
  }
});
SignatureMetadata.prototype = {};
SignatureMetadata.prototype.read = function (input) {
  input.readStructBegin();

  while (true) {
    var ret = input.readFieldBegin();
    var ftype = ret.ftype;
    var fid = ret.fid;

    if (ftype == Thrift.Type.STOP) {
      break;
    }

    switch (fid) {
      case 1:
        if (ftype == Thrift.Type.STRING) {
          this.signatureVerificationKey = input.readString();
        } else {
          input.skip(ftype);
        }
        break;
      case 2:
        if (ftype == Thrift.Type.STRING) {
          this.context = input.readString();
        } else {
          input.skip(ftype);
        }
        break;
      default:
        input.skip(ftype);
    }
    input.readFieldEnd();
  }
  input.readStructEnd();
  return;
};

SignatureMetadata.prototype.write = function (output) {
  output.writeStructBegin("SignatureMetadata");
  if (
    this.signatureVerificationKey !== null &&
    this.signatureVerificationKey !== undefined
  ) {
    output.writeFieldBegin("signatureVerificationKey", Thrift.Type.STRING, 1);
    output.writeString(this.signatureVerificationKey);
    output.writeFieldEnd();
  }
  if (this.context !== null && this.context !== undefined) {
    output.writeFieldBegin("context", Thrift.Type.STRING, 2);
    output.writeString(this.context);
    output.writeFieldEnd();
  }
  output.writeFieldStop();
  output.writeStructEnd();
  return;
};
